import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Users, Eraser } from 'lucide-react';

// Multi-select employee chips with bulk "add everyone in a functional position",
// select-all and clear. `fps` = functional positions list; employees carry functional_position_ids.
export function BulkAttendeePicker({ emps = [], fps = [], selectedIds = [], onChange, testidPrefix = 'att' }) {
  const [fpPick, setFpPick] = useState('');
  const toggle = (id) => onChange(selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id]);
  const addByFp = (fpId) => {
    setFpPick(fpId);
    if (!fpId) return;
    const ids = emps.filter(e => (e.functional_position_ids || []).includes(fpId)).map(e => e.id);
    onChange([...new Set([...selectedIds, ...ids])]);
  };
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1">
          <Users className="w-3.5 h-3.5 text-slate-400" />
          <Select value={fpPick || undefined} onValueChange={addByFp}>
            <SelectTrigger className="h-7 w-56 text-xs" data-testid={`${testidPrefix}-by-fp`}><SelectValue placeholder="Add everyone in a functional position" /></SelectTrigger>
            <SelectContent>{fps.map(fp => <SelectItem key={fp.id} value={fp.id}>{fp.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <Button type="button" size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => onChange(emps.map(e => e.id))} data-testid={`${testidPrefix}-all`}>Select all</Button>
        <Button type="button" size="sm" variant="ghost" className="h-7 text-[11px] gap-1 text-slate-500" onClick={() => { onChange([]); setFpPick(''); }} data-testid={`${testidPrefix}-clear`}><Eraser className="w-3 h-3" /> Clear</Button>
      </div>
      <div className="flex flex-wrap gap-1.5 max-h-44 overflow-y-auto">
        {emps.map(e => { const a = selectedIds.includes(e.id); return (
          <button key={e.id} type="button" onClick={() => toggle(e.id)} className={`text-[11px] px-2 py-1 rounded border ${a ? 'bg-pink-50 text-pink-700 border-pink-300' : 'bg-white text-slate-500 border-slate-200'}`} data-testid={`${testidPrefix}-${e.id}`}>{e.name}</button>
        ); })}
      </div>
    </div>
  );
}
